import React from "react";
import Proptypes from "prop-types";
import { toast } from "react-toastify";
import { noop } from "lodash-es";

import Button from "ui/Button";

import AnimatedModal from "components/Modal/AnimatedModal";
import PersonPreview from "components/PersonPreview";
import Form from "components/Form/Form";
import { addMember } from "domain/BlackLists/api";
import Textarea from "components/Form/Controls/Textarea";

const AddToBlackListModal = ({ player = {}, groupId, onClose, updateBlackList }) => {
    const { id, family_name, name, avatar } = player;

    const onSuccess = (blackList) => {
        updateBlackList(groupId, blackList);
        onClose();
    };
    const onError = (e) => {
        toast.error(`Не удалось добавить игрока в группу${e.message}`);
    };

    return (
        <AnimatedModal
            onClose={onClose}
            title="Выберите город"
            modificators={["medium-col"]}
        >
            {() => {
                return (
                    <Form
                        id="create-profile"
                        submit={addMember}
                        onError={onError}
                        onSuccess={onSuccess}
                        className="reg__form"
                    >
                        {({ error, invalidFields }) => (
                            <div>
                                <PersonPreview
                                    id={id}
                                    key={`player-list-item-${id}`}
                                    family_name={family_name}
                                    name={name}
                                    avatar={avatar}
                                    mods={[`person--row`]}
                                    onClick={noop}
                                />

                                <p className="fs-body1 c-gs-medium-em text-center mt-24">
                                    Опишите, почему вы хотите добавить игрока в
                                    черный список.
                                </p>
                                <input
                                    type="hidden"
                                    name="user_id"
                                    value={player.id}
                                />
                                <input
                                    type="hidden"
                                    name="groupId"
                                    value={groupId}
                                />
                                <div className="mt-24">
                                    <Textarea
                                        placeholder="Не оплатил площадку, ругался матом, намусорил в раздевалке и т.д."
                                        name={`reason`}
                                        error={error}
                                        invalidFields={invalidFields}
                                    />
                                </div>
                                <div className="mt-24">
                                    <Button type="submit" primary fullWidth>
                                        Добавить в черный список
                                    </Button>
                                </div>
                            </div>
                        )}
                    </Form>
                );
            }}
        </AnimatedModal>
    );
};

AddToBlackListModal.propTypes = {
    player: Proptypes.object.isRequired,
    groupId: Proptypes.number.isRequired,
    updateBlackList: Proptypes.func.isRequired,
    onClose: Proptypes.func.isRequired,
};

export default AddToBlackListModal;
